module.exports = __webpack_public_path__ + "img/img15.757bb49e.svg";